import types from './types'

const coachActions = {
  setCoach: (coach: Coach): ReduxAction => ({ type: types.SET_COACH, payload: coach }),
  setCoaches: (coach: Coach[]): ReduxAction => ({ type: types.SET_COACHES, payload: coach }),
}

export default coachActions
